export default {
  'discover-more': 'Discover More',
  'tap-to-see': 'Tap<br> to see other',
  'scroll-down': 'Scroll down',
  'all-projects': 'All projects',
  all: 'All',
  readBlog: 'Read article',
  'load-more': 'Load more',
  back: 'Back to Homepage',
  read: 'Read',
}
